// removed by extract-text-webpack-plugin
module.exports = {"activation":"_1S0FnyOi","content":"_3FJ0K_dr","details":"GUiEAgv7","link-emphasis":"IImTcp6a"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/pages/AccountVerificationPage/AccountVerificationPage.styl
// module id = 352
// module chunks = 0